import React from 'react';
import _ from 'lodash';
import { Box, Card, CardHeader, CardContent, Typography, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { Logo } from '../../components/landing/Logo';

export const TransactionCompleted = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = searchParams.get('params');

  return (
    <Card sx={{ height: '100%' }}>
      <Logo url="https://sun-sport.pl" />
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
        <CardHeader title="Transakcja opłacona" sx={{ mt: 5 }} />
        <CardContent>
          <Typography>Płatność dotycząca umowy: <b>{!_.isEmpty(params) ? params.split(';')[0] : ''}</b></Typography>
          <Typography>Na kwotę: <b>{!_.isEmpty(params) ? params.split(';')[1] : ''} zł</b></Typography>
          <Typography>Status: <b style={{ color: 'green' }}>Zrealizowana</b></Typography>
          <p>&nbsp;</p>
          <p>Możesz teraz zamknąć tę stronę lub wrócić na stronę Sun-Sport: <a href="https://sun-sport.pl/">https://sun-sport.pl/</a> lub Zielone Szkoły: <a href="https://zielone-szkoly.com">https://zielone-szkoly.com</a></p>

          <Stack direction="row" spacing={2} mt={5}>
            <Card>
              <CardHeader title="Obozy letnie"/>
              <CardContent>
                <p>W przypadku pytań lub wątpliwości prosimy o kontakt mailowy lub telefoniczny: <b>+48 602 119 000</b></p>
                <p>W przypadku wyjazdu do Mrówek: <b>mrowki@sun-sport.pl</b></p>
                <p>W przypadku wyjazdu do Giewartowa: <b>giewartow@sun-sport.pl</b></p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader title="Zielone szkoły"/>
              <CardContent>
                <p>W przypadku pytań lub wątpliwości prosimy o kontakt mailowy lub telefoniczny: <b>+48 664 720 861</b></p>
                <p>Kontakt mailowy: <b>zielone-szkoly@sun-sport.pl</b></p>
              </CardContent>
            </Card>
          </Stack>

        </CardContent>
      </Box>
    </Card>
  );
};
